import React, { useContext, useState } from "react";
import {
  FaHome,
  FaUsers,
  FaCalendarAlt,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import { Context } from "../../context/Context";
import { useNavigate } from "react-router-dom";

const SidebarUser = ({ setActiveComponent }) => {
  const { setToken } = useContext(Context);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken("");
    navigate("/");
  };

  return (
    <div>
      {/* Przycisk otwierania menu */}
      <button
        className="md:hidden p-4 text-[#313131]"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-[#f5ebdc] border-r border-[#313131] 
        transform ${
          isOpen ? "translate-x-0" : "-translate-x-64"
        } md:translate-x-0 
        transition-transform duration-300 md:relative md:flex md:flex-col`}
      >
        <div className="p-5 text-center text-lg font-bold border-b border-[#313131] text-[#313131]">
          Panel Użytkownika
        </div>

        <ul className="flex-1 p-4 space-y-4">
          {[
            { name: "Profil", icon: <FaHome /> },
            { name: "Kalendarz", icon: <FaCalendarAlt /> },
            { name: "Karnety", icon: <FaUsers /> },
            { name: "Treningi", icon: <FaCalendarAlt /> },
            { name: "Platności", icon: <FaCalendarAlt /> },
            { name: "Dopobrania", icon: <FaCalendarAlt /> },
            { name: "Linki", icon: <FaCalendarAlt /> },
          ].map((item) => (
            <li
              key={item.name}
              onClick={() => {
                setActiveComponent(item.name);
                setIsOpen(false);
              }}
              className="flex items-center space-x-3 p-3 rounded-lg bg-[#313131] cursor-pointer text-white"
            >
              {item.icon}
              <span>{item.name}</span>
            </li>
          ))}
        </ul>

        <div className="p-4 border-t border-[#313131]">
          <button
            className="w-full p-2 bg-red-500 hover:bg-red-600 rounded-lg text-sm transition duration-200"
            onClick={handleLogout}
          >
            Wyloguj
          </button>
        </div>
      </div>
    </div>
  );
};

export default SidebarUser;
